import { useState } from 'react';
import { validateStockUrl } from '../../utils/validation';

const StockForm = ({ onAdd }) => {
  const [url, setUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const validation = validateStockUrl(url);
    if (!validation.isValid) {
      setError(validation.message);
      return;
    }

    setIsLoading(true);
    setError(null);
    try {
      await onAdd(url);
      setUrl('');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="stock-form">
      <input type="text" value={url} onChange={(e) => {
          setUrl(e.target.value);
          setError(null); // Clear error when typing
        }}
        placeholder="https://www.boursedirect.fr/..."
        required
      />
      {error && <div className="error-message">{error}</div>}
      <button type="submit" disabled={isLoading || !url}> {isLoading ? 'Adding...' : 'Track Stock'} </button>
    </form>
  );
};

export default StockForm;